import * as React from 'react';
import PropTypes from 'prop-types';
import appState from '../../state/AppStateContainer';
import Tabs from '../../components/shared/Tabs'

import './styles.css';
import AppLayout from '../../components/layout/app-layout/app-layout';
import AppEditDemands from '../app-edit-options/app-edit-demands';
import AppEditPriceFields from '../app-edit-options/app-edit-price-fields';
import AppEditErfaQuestions from '../app-edit-options/app-edit-erfa-questions';
import AppEditCategories from '../app-edit-options/app-edit-categories';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import AppEditPriceUnits from '../app-edit-options/app-edit-price-units';
import OrganizationSettings from './OrganizationSettings';
import { useTranslation } from 'react-i18next';
import SupplierApplicationFormSettings from './SupplierApplicationFormSettings';
import BtButton from '../bt-button/bt-button';
import UserList from '../app-user-management/user-list';
import { canManageOrgSettings, canViewUsers } from '../../util/settingsAccess';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      className="custom-tab-style"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {(value === index) && children}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function PageSettings({ history }) {
  const [t] = useTranslation('settings');
  const [t2] = useTranslation('supplierDatabase', { keyPrefix: 'tableTopActions' });
  const [tUsers] = useTranslation('users');
  const url = appState._getCurrentOrgUrl() + '/settings';
  const role = appState.getUserRole();
  const canManage = canManageOrgSettings(role);
  const isPurchasing = appState.isPurchasingActive();
  const [addNewAreaModal, setAddNewAreaModal] = React.useState(false);
  const [addMemberModalOpen, setAddMemberModalOpen] = React.useState(false);

  const tabs = [
    {
      title: t('tabs.general', 'Allmänt'),
      link: '',
      component: <OrganizationSettings />,
      show: canManage,
    },
    {
      title: t('tabs.users', 'Användare'),
      link: '/users',
      component: <UserList addMemberModalOpen={addMemberModalOpen} setAddMemberModalOpen={setAddMemberModalOpen} />,
      show: canViewUsers(role),
      action: canManage && (
        <div className="tab-actions">
          <BtButton onClick={() => setAddMemberModalOpen(true)}>{tUsers('button.addMember', 'Lägg till användare')}</BtButton>
        </div>
      ),
    },
    {
      title: t('tabs.priceFields', 'Prisfält'), 
      link: '/price-fields',
      component: <AppEditPriceFields />,
      show: canManage && isPurchasing,
    },
    {
      title: t('tabs.requirements', 'Skallkrav'), 
      link: '/requirements',
      component: <AppEditDemands />,
      show: canManage && isPurchasing,
    },
    {
      title: t('tabs.erfaQuestions', 'Erfarenhetsåterföringsfrågor'), 
      link: '/erfa-questions',
      component: <AppEditErfaQuestions />,
      show: canManage && isPurchasing,
    },
    {
      title: t('tabs.cagegories', 'Yrkeskategorier'), 
      link: '/categories',
      component: <AppEditCategories addNewAreaModal={addNewAreaModal} setAddNewAreaModal={setAddNewAreaModal} />,
      show: canManage && isPurchasing,
      action: (
        <div className="tab-actions">
          <BtButton onClick={() => setAddNewAreaModal(true)}>{t2('button.addArea', 'Lägg till kategori')}</BtButton>
        </div>
      ),
    },
    {
      title: t('tabs.priceUnits', 'Enheter'), 
      link: '/price-units',
      component: <AppEditPriceUnits />,
      show: canManage && isPurchasing,
    },
    {
      title: t('tabs.supplierApplicationForm', 'Supplier application form'), 
      link: '/supplier-application-form',
      component: <SupplierApplicationFormSettings />,
      show: canManage && isPurchasing,
    },
  ].filter(tab => tab.show);

  const tabNames = tabs.map(t => t.title);

  const handleChange = (newValue) => {
    const links = tabs.map(t => t.link);
    history.push(url + links[newValue]);
  };

  const renderRoute = (tab, i) => (
    <Route path={`${url}${tab.link}`} exact={!tab.link} key={tab.link}>
      <>
        <div className="sp-top-actions">
          <div className="tab-container settings-tab-bar">
            <Tabs tabs={tabNames} selected={i} onChange={handleChange} />
            {tab.action}
          </div>
        </div>
        {tab.component}
      </>
    </Route>
  );

  const [firstTab] = tabs;

  return (
    <AppLayout title={t('pageTitle', 'Inställningar för {{currentOrg}}', { currentOrg: appState.getCurrentOrgName() })}>
      <div className="settings-container">
        <Switch>
          {tabs.map(renderRoute)}
          {firstTab && <Redirect to={url + firstTab.link} />}
        </Switch>
      </div>
    </AppLayout>
  );
}

export default withRouter(PageSettings);